import { FormControl } from "@angular/forms";
import { FeelsMoreConfidentEnum } from "@isophi/pap-api";

export interface SelfReflectionForm {
    activityHelped: FormControl<FeelsMoreConfidentEnum | null>;
    knowledgeUsage: FormControl<FeelsMoreConfidentEnum | null>;
    challengeExperienced: FormControl<FeelsMoreConfidentEnum | null>;
    expectationsMet: FormControl<FeelsMoreConfidentEnum | null>;
    feelsMoreConfident: FormControl<FeelsMoreConfidentEnum | null>;
    selfReflectionText: FormControl<string | null>;
}

export interface SelfReflectionFormValue {
    activityHelped: FeelsMoreConfidentEnum | null;
    knowledgeUsage: FeelsMoreConfidentEnum | null;
    challengeExperienced: FeelsMoreConfidentEnum | null;
    expectationsMet: FeelsMoreConfidentEnum | null;
    feelsMoreConfident: FeelsMoreConfidentEnum | null;
    selfReflectionText: string | null;
}